export {default} from './Slider';
